import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Container from 'src/components/shared/Container';

const LinkedInEmptyPage = () => {
	const [searchParams] = useSearchParams();
	const token = searchParams.get('share');

	useEffect(() => {
		if (token) localStorage.setItem('linkedinShareToken', token);
	}, [token]);
	return (
		<Container className="w-[92%] max-w-[1366px] sm:w-[96%]">
			<div className="mb-[372px] mt-[220px] sm:mb-[100px] sm:mt-[100px]">
				<div className="flex justify-center">
					{/* <Lottie loop animationData={congratulationsCheckAnimation} play={true} style={{ width: '84px' }} /> */}
				</div>

				<div className="flex justify-center text-[24px] font-[500] text-[#FAFAFC]">
					<div className="max-w-[487px] text-center sm:max-w-[100%]">Awesome 🎉</div>
				</div>

				<div className="mt-2 flex flex-col justify-center items-center text-[16px] font-[400] text-[#C7C9D9]">
					<div className="max-w-[487px] text-center sm:max-w-[100%]">
						Your <strong>AI generated post</strong> is now live on your profile!
					</div>
					<div className="max-w-[487px] text-center sm:max-w-[100%]">Check the LinkedIn app to view now</div>
				</div>
			</div>
		</Container>
	);
};

export default LinkedInEmptyPage;
